import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon from "@insite/mobius/Icon";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AlertMessageIcon from "@tCentro/Icons/AlertMessageIcon";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: ProductAlertMessageStyles;
    alertMessage?: string;
}

type Props = OwnProps;

export interface ProductAlertMessageStyles {
    alertMessage?: TypographyProps;
    alertMessageIcon?: InjectableCss;
}

export const productAlertMessageStyles: ProductAlertMessageStyles = {
    alertMessage: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
            text-transform: capitalize;
            color: ${COLORS.alertMsgRed};
        `,
    },
    alertMessageIcon: {
        css: css`
            vertical-align: middle;
        `,
    },
};

const ProductAlertMessage: FC<Props> = ({ alertMessage }) => {
    return (
        <StyledWrapper>
            <StyledWrapper {...productAlertMessageStyles.alertMessage}><Icon src={AlertMessageIcon} {...productAlertMessageStyles.alertMessageIcon} />{alertMessage}</StyledWrapper>
        </StyledWrapper>
    );
};

export default ProductAlertMessage;
